import { Operation } from '../../../types/operation';

export const emptyOperation: Operation = {};
